import React from 'react'
import girl from '../assets/images/girl.png';

export default function Hero({ children }) {
	return (
		<section className="relative bg-gradient-to-r from-gray-300/5 via-gray-300/25 to-pink-350/25  after:relative after:flex after:h-16 after:w-full 
		before:relative before:flex before:h-16 before:w-full  overflow-x-hidden">
			<div className="container mx-auto px-24 flex flex-col lg:flex-row items-center">
				<div className="basis-1/2 z-10">
					{children}
				</div>
				<div className="basis-1/2">
					<img className="" src={girl} alt="Hero" />
				</div>
			</div>
			<div className='bottom-triangle-left absolute align-bottom'></div>
			<div className='bottom-triangle-right absolute align-bottom'></div>
		</section>
	)
}
